import {
  ActiveLine,
  Container,
  InactiveLine,
  Row,
} from "./progressIndicator.styled";

interface ProgressIndicatorProps {
  readonly currentStep: number;
  readonly steps: number;
}

export const ProgressIndicator = (
  props: ProgressIndicatorProps,
): JSX.Element => (
  <Row>
    {Array.from({ length: props.steps }, (_, index) => (
      <Container key={index}>
        {props.currentStep >= index + 1 ? <ActiveLine /> : <InactiveLine />}
      </Container>
    ))}
  </Row>
);
